import FilterMenu from "./filtermenu.js";
import LogMetrics from "./logmetrics.js";
import PriceRangeFilter from "./pricerangefilter.js";
import { prodListValues } from './shared.js';

const verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value ?? '';
const productContainer = document.getElementById('productContainer');

class DataService {
    /**
     * Fetches products based on the given path and updates the UI accordingly.
     * @async
     * @param {string} path 
     * @param {boolean} updateUrl 
     * @param {string} newPathToUse 
     * @returns {Promise<void>}
     */
    async getProducts(path, updateUrl, newPathToUse) {
        const loading = document.getElementById('loadingItems');
        const loadingHTML = '<div id="listLoading" class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';

        loading.classList.remove('hide');
        document.getElementById("loadingItems").querySelector(".spinnerCtrPg").innerHTML = loadingHTML; // insert HTML so screen reader announces it
        // note: scrolling to top is disorienting for a11y users

        try {
            const response = await fetch('/list/v2/filter' + path, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', 'RequestVerificationToken': verificationToken, '__RequestVerificationToken': verificationToken }
            });

            const data = response.ok ? await response.json() : [];

            // Update the filter menu with new filters.
            FilterMenu.updateMenuSelections(data.ProductFilter);
            document.getElementById('productCount').textContent = data.ItemCountLabel;

            // Update with the new filter results.
            productContainer.innerHTML = data.ProductView;
            productContainer.insertAdjacentHTML("afterbegin", '<div id="loadingItems" class="hide"><div class="spinnerOverlay"></div><div class="spinnerCtrPg"></div></div>');
            LogMetrics.setOnClick();
            // pager may not always be present if only one page of products exist
            document.querySelectorAll('.pagingWrapper').forEach(element => {
                element.innerHTML = data.PagerView;

                // fix up for bottom pager
                data.PagerView = data.PagerView.substr(data.PagerView.indexOf('</p>') + 4).replace(' - Top', ' - Bottom');
            });

            PriceRangeFilter.update(data.MinPrice, data.MaxPrice, false);

            const structureData = document.getElementById('structureddata');

            if (structureData) {
                structureData.innerHTML = data.StructuredData;
            }

            loading.classList.add('hide');

            if (document.getElementById("listLoading")) {
                document.getElementById("listLoading").parentNode.removeChild(document.getElementById("listLoading"));
            }

            //focus management - first product
            setTimeout(function () {
                const item = document.querySelector(".productList").querySelector("a");
                if (item) {
                    item.focus();
                }
            }, 350);

            if (updateUrl === true) {
                prodListValues.replaceCurrentUrl(newPathToUse, document.getElementById('BaseTitle').value, document.getElementById('BaseDescription').value, document.getElementById('BaseKeywords').value);
            }
        }
        catch (error) {
            // try reloading page with new filter path
            console.error(error);
            window.location.href = path;
        }

        return;
    };

    /**
     * Logs a filter interaction.
     * @param {string} filterId 
     * @param {string} filtervalue 
     * @returns {void}
     */
    filterLog(filterId, filtervalue) {
        // check if we need to wait until js finishes parsing 
        if (typeof ajax === 'function') {
            this.saveFilter(filterId, filtervalue);
        } else {
            setTimeout(() => { this.saveFilter(filterId, filtervalue); }, 2000);
        }
    };

    /**
     * Saves a filter interaction.
     * @param {string} filterId 
     * @param {string} filtervalue 
     * @returns {void}
     */
    async saveFilter(filterId, filtervalue) {
        const account = typeof s_account === 'string' ? s_account : '4imprintprod';
        const s = typeof s_gi === 'function' ? s_gi(account) : "";

        let filtertype = filterId === "MoreFiltersButton"
            ? filterId
            : document.getElementById(filterId)
                ? document.getElementById(filterId).getAttribute('data-group')
                : '';

        let pagetype = '';
        let pagevalue = '';

        // Log in Omniture.
        if (s !== "") {
            if (filtertype !== 'SubSearch') {
                s.prop18 = filtertype + ' : ' + filtervalue; // List Filter prop
                s.prop19 = filtertype; // List Filter Group prop
                s.eVar30 = s.prop18;
                s.eVar32 = s.prop18;
                s.prop22 = '';
            } else {
                s.prop18 = '';
                s.prop19 = '';
                s.eVar30 = '';
                s.eVar32 = '';
                s.prop22 = filtervalue;
            }

            pagetype = s.prop12;
            if (s.prop12 === 'Search') {
                pagevalue = s.prop1; // internal search prop
            } else {
                pagevalue = s.prop7; // groupname, taggroupname, or storename
            }

            s.t();
        }

        if (filtertype === null) filtertype = '';
        if (typeof filtervalue === 'undefined') filtervalue = '';

        const logFilterModel = {
            PageType: pagetype,
            PageValue: pagevalue,
            FilterType: filtertype,
            FilterValue: filtervalue,
        };

        try {
            const response = await fetch('/filters/v2/logfilter', {
                method: 'POST',
                body: JSON.stringify(logFilterModel),
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', 'RequestVerificationToken': verificationToken, '__RequestVerificationToken': verificationToken }
            });

            const data = response.ok ? await response.text() : [];
        } catch (error) {
            console.error(error);
        }
    };
}

export default new DataService();